export const applicationRouteNames = {
  home: 'hpc',
  administration: 'administration',
  users: 'users',
  lokalise: 'lokalise',
  zouma: 'zouma',
  ziiko: 'ziiko',
  dashboard: 'dashboard',
  lunch: 'lunch',
  mps: 'mps',
  hpc: 'hpc',
};
